import  {
    Document,
    Page,
    Text,
    View
  } from "@react-pdf/renderer";

  import ItemDetails from "../CommonPdfComponents/ItemDetails";
  import { useEffect, useState } from "react";
  import PaymentDetails from "./PurchaseOrderPaymentDetails";
  import moment from "moment";
 
  import { checkingForGstSummaryHeaders, checkingForHeaders } from "../CommonPdfComponents/utils";
import BillFromAndLogo from "./BillFromAndLogo";
import { styles } from "../GenericPdf/style";
import DynamicItemDetails from "./PurchaseOrderItemDetails";
import { GST_SUMMARY_HEADERS, SinglePdfHeaderType, tableHeaders } from "../GenericPdf/constant";
import { InvoiceGstSummaryDetails } from "../../../../commonTypes/invoiceGenerationTypes";
  
  type AppProps = {
    downloadRevenuesData: any;
    currencySign: string | undefined;
    currencyShortForm: string | undefined;
  };
  
  const PurchaseOrderPdf = ({
    downloadRevenuesData,
    currencySign,
    currencyShortForm,
  }: AppProps) => {
    const [data, setData] = useState<any>({});
    const [finalTableHeader, setFinalTableHeader] = useState<
      SinglePdfHeaderType[]
    >([{ name: "", column_value: "" }]);
    const [finalGstSummaryTableHeader, setFinalGstSummaryTableHeader] = useState<
    SinglePdfHeaderType[]
    >([{ name: "", column_value: "" }]);

    const [isGstSummary,setIsGstSummary]=useState(false)

    // useEffect(() => {
    //   if (downloadRevenuesData) {
    //     const checkedDownloadRevenueData = checkingForHeaders(downloadRevenuesData?.item_details,tableHeaders);
    //     setData({ ...downloadRevenuesData });
    //     setFinalTableHeader([...checkedDownloadRevenueData]);
    //   }
    // }, [downloadRevenuesData]);

    useEffect(()=>{
      if(downloadRevenuesData?.gst_summary_details){
        downloadRevenuesData?.gst_summary_details?.forEach((item:InvoiceGstSummaryDetails)=>{
          if(+item?.gst_percentage>0){
          return setIsGstSummary(true)
          }
        })
        }
    },[downloadRevenuesData?.gst_summary_details])

      useEffect(() => {
        if (downloadRevenuesData) {
          const checkedDownloadRevenueData = checkingForHeaders(
            downloadRevenuesData?.item_details,
            tableHeaders,
            "withoutSku"
          );
          setData({ ...downloadRevenuesData });
          setFinalTableHeader([...checkedDownloadRevenueData]);
          const checkedGstSummaryDataHeaders = checkingForGstSummaryHeaders(
            downloadRevenuesData?.gst_summary_details,
            GST_SUMMARY_HEADERS
          );
          setFinalGstSummaryTableHeader([...checkedGstSummaryDataHeaders]);
        }
      }, [downloadRevenuesData]);
    
   
    
  
    return (
      <Document>
        <Page size={"A4"} style={styles.body}>
          {/* bill from and logo  */}
          <BillFromAndLogo downloadRevenuesData={data} isFixed={true}/>
  
          {/* Item Details  */}
          <DynamicItemDetails
            downloadRevenuesData={data}
            tableHeaders={finalTableHeader}
            currencySign={currencySign}
            finalGstSummaryTableHeader={finalGstSummaryTableHeader}
            currencyShortForm={currencyShortForm}
            isGstSummary={isGstSummary}
          />
          {/* payment Details  */}
          <View style={{ marginTop: "25px", marginRight: "4px" }}>
            <PaymentDetails downloadRevenuesData={data} />
          </View>
  
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
  
          <Text style={styles.time} fixed>
            document generated at{" "}
            {`${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}`}
          </Text>
        </Page>
      </Document>
    );
  };
  
  export default PurchaseOrderPdf;
  